import styled from 'styled-components';
import BaseBox from '@tds/core-box';
import { colorTelusPurple } from '@tds/core-colours';
import PropTypes from 'prop-types';

export const DashboardWrapper = styled(BaseBox)`
  height: 100%;
`;

export const TopbarWrapper = styled(BaseBox)`
  background: ${colorTelusPurple};
  width: 100%;
  padding: 1rem 2rem;
  justify-content: space-between;
  @media screen and (max-width: 992px) {
    padding: 16px;
  }
`;

export const SidebarWrapper = styled(BaseBox)`
  ul {
    display: table;
    border: 1px solid red;
  }
  ul li {
    padding-right: 20px;
    display: table-cell;
    line-height: 30px;
    font-weight: 500;
  }

  ul li a {
    text-decoration: none !important;
  }
`;

export const ContentWrapper = styled(BaseBox)`
  width: 100%;
  padding: 2rem;
  background-color: white;
  display: flex;
  min-height: 900px;
`;

export const LeftMenu = styled(BaseBox)`
  width: ${props => props.width}%;
  display: flex;
  justify-content: start;
  flex-direction: row;
  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    flex-wrap: wrap;
  }
`;

export const RightMenu = styled(BaseBox)`
  width: ${props => props.width}%;
  justify-content: flex-end;
  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    flex-wrap: wrap;
  }
`;

export const Box = styled(BaseBox)`
  width: ${props => props.width}%;
  display: ${props => props.display};
  flex-direction: ${props => props.flexDirection};
  flex-wrap: ${props => props.flexWrap};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  padding-bottom: ${props => props.pb}px;
  padding-top: ${props => props.pt}px;
  padding-right: ${props => props.pr}px;
  padding-left: ${props => props.pl}px;
  margin-top: ${props => props.mt}px;
  margin-right: ${props => props.mr}px;

  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    justify-content: ${props => props.mdJustifyContent};
    padding: ${props => props.mdPadding};
  }
`;

export const LinkButton = styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  margin: 0 5px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
  }
`;

export const Button = styled.button`
  border: none;
  padding: 0;
  cursor: pointer;
  color: #49166d;
  background: none;

  :hover {
    text-decoration: underline;
  }
`;

export const FormBox = styled.div`
  width: 100%;
  position: relative;
`;

export const Text = styled.span`
  color: ${props => props.color};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight};
  letter-spacing: -0.8px;
  line-height: 1.5;
  word-wrap: break-word;
`;

Text.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.number
};

Text.defaultProps = {
  color: '#2a2c2e',
  fontSize: '1rem',
  fontWeight: 700
};

export const Overlay = styled.div`
  z-index: 10001;
  background-color: #ffffff;
  position: fixed;
  top: 100px;
  left: 50%;
  margin-left: -200px;
  width: 400px;
  border-style: solid;
  border-width: 1px;
  border-color: #e2e2e2;
  text-align: center;
  padding: 20px;
  display: none;
`;

export const OverlayLayer = styled.div`
  z-index: 10000;
  filter: alpha(opacity=50); /*older IE*/
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50); /* IE */
  -moz-opacity: 0.5; /*older Mozilla*/
  -khtml-opacity: 0.5; /*older Safari*/
  opacity: 0.5; /*supported by current Mozilla, Safari, and Opera*/
  background-color: #000000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  display: none;
`;

export const SignatureContainer = styled.div`
  max-width: 400px;
  background-color: #e4e4e4;
`;

export const NoInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderButton = styled.button`
  border: none;
  padding: 2px 1rem;
  color: #fff;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  background: none;
`;
